import { useEffect, useRef } from "react";

interface IBreadcrumbContainer {
  children: JSX.Element[];
}

const BreadcrumbContainer = ({
  children,
}: IBreadcrumbContainer): JSX.Element => {
  const breadcrumbContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scrolls initially to tthe div to bottom (most right)
    // Works properly on build, on development server it has issue because of wrong initial font
    breadcrumbContainerRef.current?.scrollTo({
      left: breadcrumbContainerRef.current?.scrollWidth,
      behavior: "auto",
    });
  }, []);

  return (
    <nav
      className={`no-scrollbar h-[1.1875rem] overflow-y-scroll desktop:w-fit desktop:overflow-hidden`}
      ref={breadcrumbContainerRef}
      aria-label="breadcrumb"
    >
      <ol className="flex flex-row gap-2">{children}</ol>
    </nav>
  );
};

export default BreadcrumbContainer;
